import { render, staticRenderFns } from "./CodeSentEmailComponent.vue?vue&type=template&id=1c138310&scoped=true"
import script from "./CodeSentEmailComponent.vue?vue&type=script&lang=js"
export * from "./CodeSentEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c138310",
  null
  
)

export default component.exports